import "alpine-turbo-drive-adapter";
import Alpine from "alpinejs";

window.Alpine = Alpine;

// Shared countdown component used by the course sticky header, mobile bottom
// bar and landing page hero to create urgency towards the next event.
document.addEventListener("alpine:init", () => {
  const pad = (value) => String(value).padStart(2, "0");

  const calcRemaining = (target) => {
    const diff = Math.max(0, new Date(target) - new Date());
    return {
      days: pad(Math.floor(diff / 86400000)),
      hours: pad(Math.floor((diff % 86400000) / 3600000)),
      minutes: pad(Math.floor((diff % 3600000) / 60000)),
      seconds: pad(Math.floor((diff % 60000) / 1000)),
    };
  };

  Alpine.data("countdown", (target) => ({
    days: "00",
    hours: "00",
    minutes: "00",
    seconds: "00",
    init() {
      const update = () => Object.assign(this, calcRemaining(target));
      update();
      this._timer = setInterval(update, 1000);
    },
    destroy() {
      clearInterval(this._timer);
    },
  }));
});

Alpine.start();